module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2BAMAAAB+a3fuAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAkUExURUdwTEBw+Dpr9zpr9zxt9zxs+Dxr9zxs+Dpq90Nu/zpr9zpq9lBHXtUAAAALdFJOUwAg4f1ePlxx1hWfKp0BWwAAANZJREFUOMvV1DEKwkAQBdAJBCJWIgiClVim1QVJE/AMKcQmZ9DSRku7FN7CLosozOWcMSkE/z9AptnAn0dmYBORwdaeR/NYsyjJY2DZVJXBJFfVQBmDxuKRQGNrz2vMSm8IkIWuo8bs27IFrG3szDRu0G43e9ipXtBu70bSQtvJ/9seDo0twW6ZwTtmpZxVV5j5iFaYiUPCRMacsSH9TIvhspqwUX93AJMDZ5a9GLPsyVifQdZnkHUZZj5LVZ0gs0zRLfnNEJMFZ359rK74I59VVsP9WX4AR0agkledXFIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tip/icon-outlined-24-lg-1-menu-copy-4.png
// module id = YVSg
// module chunks = 1